import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServicePage from "./pages/ServicePage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import ContactPage from "./pages/ContactPage";
import GeoPage from "./pages/GeoPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import GalleryPage from "./pages/GalleryPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import SepticTankInstallationPage from "./pages/SepticTankInstallationPage";
// import CommercialSepticPage from "./pages/CommercialSepticPage";
import SepticDesignPage from "./pages/SepticDesignPage";
import BlogPage from "./pages/BlogPage";
import InformationCentrePage from "./pages/InformationCentrePage";
import BlogPostPage from "./pages/BlogPostPage";
import DivisionsPage from "./pages/DivisionsPage";
import SepticCalculatorPage from "./pages/SepticCalculatorPage";
import SepticSystemCostOntarioGuide from "./pages/SepticSystemCostOntarioGuide";
import PercolationTestThunderBayGuide from "./pages/PercolationTestThunderBayGuide";
import SepticTankInstallationCostOntarioGuide from "./pages/SepticTankInstallationCostOntarioGuide";
import EljenGSFSystemOntarioGuide from "./pages/EljenGSFSystemOntarioGuide";
import SepticSystemReplacementCostThunderBayGuide from "./pages/SepticSystemReplacementCostThunderBayGuide";
import ThunderBaySepticSystemsHub from "./pages/ThunderBaySepticSystemsHub";
import SepticSystemReplacementThunderBayPage from "./pages/SepticSystemReplacementThunderBayPage";
import RothMultiTankServicePage from "./pages/RothMultiTankServicePage";


import NotFoundPage from "./pages/NotFoundPage";
import { DataProvider } from "./context/DataContext";
import { Toaster } from "./components/ui/toaster";
import FloatingCTA from "./components/FloatingCTA";
import ScrollToTop from "./components/ScrollToTop";
import { SiteMotion } from "./components/SiteMotion";
import "@fontsource-variable/archivo";
import "@fontsource-variable/dm-sans";
import "@fontsource/jetbrains-mono/400.css";
import "./App.css";
import "./styles/site-refresh.css";
import "./styles/home-refresh.css";

function App() {
  return (
    <div className="App">
      <DataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SiteMotion />
          <a href="#main-content" className="gh-skip-link" data-testid="skip-to-content">Skip to content</a>
          <FloatingCTA />
          <div id="main-content" className="site-content" tabIndex={-1}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          
          {/* SEO Service Redirects - Old slugs → New slugs */}
          <Route path="/services/new-traditional-septic" element={<Navigate to="/services/septic-system-installation-thunder-bay" replace />} />
          <Route path="/services/eljen-mound-installation" element={<Navigate to="/services/septic-system-installation-thunder-bay" replace />} />
          <Route path="/services/traditional-septic-replacement" element={<Navigate to="/services/septic-field-installation-replacement-thunder-bay" replace />} />
          <Route path="/services/eljen-replacement" element={<Navigate to="/services/septic-field-installation-replacement-thunder-bay" replace />} />
          <Route path="/services/septic-tank-replacement" element={<Navigate to="/services/septic-tank-installation-thunder-bay" replace />} />
          <Route path="/services/septic-system-repairs" element={<Navigate to="/services/septic-repair-near-me" replace />} />
          <Route path="/services/commercial-septic" element={<Navigate to="/services/septic-system-replacement-thunder-bay" replace />} />
          <Route path="/commercial-septic-systems" element={<Navigate to="/services/septic-system-replacement-thunder-bay" replace />} />
          {/* Legacy Eljen service URL from older content */}
          <Route path="/services/eljen-system" element={<Navigate to="/services/septic-system-installation-thunder-bay" replace />} />
          
          <Route path="/thunder-bay/septic-systems" element={<ThunderBaySepticSystemsHub />} />
          <Route path="/services/septic-system-replacement-thunder-bay" element={<SepticSystemReplacementThunderBayPage />} />
          <Route path="/services/roth-multitank-supplier-thunder-bay" element={<RothMultiTankServicePage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:city" element={<GeoPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/septic-tank-installation" element={<Navigate to="/services/septic-tank-installation-thunder-bay" replace />} />
          {/* /commercial-septic-systems redirected above for SEO coverage */}
          <Route path="/septic-system-design" element={<Navigate to="/services/septic-system-installation-thunder-bay" replace />} />
          <Route path="/services/system-design" element={<Navigate to="/services/septic-system-installation-thunder-bay" replace />} />

          <Route path="/information-centre" element={<InformationCentrePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/divisions" element={<DivisionsPage />} />
          <Route path="/septic-calculator" element={<SepticCalculatorPage />} />
          <Route path="/guides/septic-system-cost-ontario" element={<SepticSystemCostOntarioGuide />} />
          <Route path="/guides/percolation-test-thunder-bay-ontario" element={<PercolationTestThunderBayGuide />} />
          <Route path="/guides/septic-tank-installation-cost-ontario" element={<SepticTankInstallationCostOntarioGuide />} />
          <Route path="/guides/septic-system-replacement-cost-thunder-bay" element={<SepticSystemReplacementCostThunderBayGuide />} />
          <Route path="/guides/eljen-gsf-system-ontario" element={<EljenGSFSystemOntarioGuide />} />
          {/* 404 - Catch all unmatched routes */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
          </div>
      </BrowserRouter>
      <Toaster />
      </DataProvider>
    </div>
  );
}

export default App;